import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import elearningRoutes from 'modules/trainingLibrary/Elearning/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ElearningDetailsRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsElearningDetails" */ 'modules/activityDetails/ElearningDetails/pages/ElearningDetails'
    )
)

const ElearningDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:elearningId/:requirementId`}
        component={ElearningDetailsRoute}
      />
      <Redirect path='*' to={elearningRoutes.root} />
    </Switch>
  </Suspense>
)

export default ElearningDetailsRouting
